
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"id":"Ellipse_437","data-name":"Ellipse 437","cx":"12","cy":"12","r":"12","fill":"rgba(107,119,134,0.1)"}}),_c('g',{attrs:{"id":"Group_27149","data-name":"Group 27149","transform":"translate(8.293 8.721)","fill":"none","stroke":"#5a677c","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M4.562 6.56L11.549 0","transform":"translate(-4.562)"}}),_c('path',{attrs:{"id":"Path_2-2","data-name":"Path 2","d":"M11.549 6.559L4.562 0","transform":"translate(-4.562)"}})])])
          )
        }
      }
    